import { OnOffToggleButtonValue } from '../on-off-toggle-button/helpers';
import { McpAction } from '@/lib/models/policy-model/mcp-controls';

export const actionToToggleValue = (action: McpAction | undefined): OnOffToggleButtonValue => {
  if (action === 'read') {
    return true;
  }
  if (action === 'read-write') {
    return false;
  }
  return undefined;
};

export const toggleValueToAction = (toggleValue: OnOffToggleButtonValue): McpAction | undefined => {
  if (toggleValue === true) {
    return 'read';
  }
  if (toggleValue === false) {
    return 'read-write';
  }
  return undefined;
};
